<template>
  <div>
    <label :for="inputId" v-if="index === 0">{{name}}</label>
    <b-form-input v-if="type !== 'number'" :id="inputId" :type="type" :value="value" @input="onInput"></b-form-input>
    <b-form-input v-else :id="inputId" :type="type" :value="value" :step="name === 'Anzahl' ? 1 : 0.01" :min="0.00" @input="onInput"></b-form-input>
    <slot></slot>
  </div>
</template>

<script>

export default  {
  props: ['index', 'name', 'type', 'value'],
  computed: {
    inputId(){
      return this.index + '-'+ this.name
    }
  },
  methods: {
    onInput(value){
      this.$emit('input', value);
    }
  }
}
</script>

<style>
.form-inline .form-control, .form-inline .custom-select, .form-inline .input-group {
  width: 100%;
  background: transparent;
}

.form-inline .form-control:hover, .form-inline .custom-select:hover, .form-inline .input-group:hover {
  border: 1px solid gray;
  background: white;
}
</style>
